export const HEADER_MOBILE_HEIGHT_CSS_VAR = "--sizes-headerMobileTopHeight";
export const HEADER_TOP_HEIGHT_CSS_VAR = "--sizes-headerTopHeight";

export const setHeaderHeightCssVars = (hasHeader: boolean) => {
    if (typeof document === "undefined") {
        return;
    }

    if (hasHeader) {
        document.documentElement.style.removeProperty(HEADER_MOBILE_HEIGHT_CSS_VAR);
        document.documentElement.style.removeProperty(HEADER_TOP_HEIGHT_CSS_VAR);
        return;
    }

    document.documentElement.style.setProperty(HEADER_MOBILE_HEIGHT_CSS_VAR, "0px");
    document.documentElement.style.setProperty(HEADER_TOP_HEIGHT_CSS_VAR, "0px");
};
